/* eslint-disable max-len */
/* eslint-disable no-console */

import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useOidc } from '@axa-fr/react-oidc';
import { useNavigate, Link } from 'react-router-dom';
import { Backdrop, CircularProgress, Tooltip } from '@mui/material';  // eslint-disable-next-line
import InfiniteScroll from 'react-infinite-scroll-component';
// add library for filter @shekhar Start
import Radio from '@mui/material/Radio';

import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
// add library for filter @shekhar End
import { notification } from 'antd';
// redux
// import { VeoliaButton } from '@veolia.com/vds-react-components';
import { decryptDataSharedAndMyProject, get_all_my_projects_list, get_checkAPI_My_Project, getMyAndSharedFile, getMyProjectAllData, getMyProjectsList, set_checkAPI_My_Project, setMyAndSharedFile } from '../userData';
import FileShare from '../file_sharing';
import { shareImage, quickViewImage, searchImage, sortAlphaImageAZ, sortAlphaImageZA, DownloadSvgIcon, deleteImage, closeIconBlack, filterCheck, filter_list, filter_alt, Icon_Button_Restart, folder_open_icon } from '../../shared/assets/images';
import Notification from '../../shared/notification-modal';
import { checkFileExists, saveWinflowsFileContent, getWinflowsFileContent, deleteWinAndProjectFile } from '../../shared/api/url-helper';
import { defaultModalOptions } from '../../shared/constantVariable';
import HeaderSection from '../header-section';
import QuickViewPopUp from './quick-view';
import './my-projects.scss';
import { encrypt_data, decrypt_data } from '../../shared/utils';
import { getEmailUserType, removeLocalStorageValue } from '../../shared/helper';
import { removeItemFromLocalStorage } from '../../shared/removeElements';
import { DownloadMainfile } from '../files_details';
// import { fetchFolderStructure } from './data/FolderData';
// import Folder from './FileExplorer';
import { clearLogs } from '../../logger';
import useTraverseTree from './hooks/use-traverse-tree';

let ColorChangeShare = false;
const dataLimit = 20;
let copyofMyFilesLength = 0;
let searchFilterflag = true;
let applyAllStr = false;

// let dateOrderBoolean = false;
const MyProjectsPopup = () => {
  const { isAuthenticated } = useOidc();
  // redux
  // const myFilesResSlice = useSelector((state) => state.projectFiles);
  // const  = useSelector(state => state.translations.LandingTranslateObject);
  if (isAuthenticated) {
    if (sessionStorage.getItem('expTime') == null) {
      clearLogs();
      window.location.href = '/sign-in';
    }
  }
  // if (sessionStorage.getItem('expTime') == null) {
  //   window.location.href = '/sign-in';
  // }

  const navigate = useNavigate();
  const [scrollMyData, setScrollMyData] = useState(true);
  const { t } = useTranslation();
  const translateObject = t;
  const [pageNumber, setPageNumber] = useState(1);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [visible_fileSharing, setVisible_fileSharing] = useState(false);
  const [text, setText] = useState('');
  const [value, setValue] = React.useState([]);
  const [selectedCities, setSelectedCities] = useState(null);
  const [flowSheetType, setFlowSheetType] = React.useState([]);
  const [subflowSheetType, setSubflowSheetType] = React.useState({});
  const [currentActiveTab, setCurrentActiveTab] = useState(0);
  const [showQuickViewPopup, setShowQuickViewPopup] = useState(false);
  const [applyUpdate, setApplyUpdate] = useState(true);
  const [showSortingPopup, setShowSortingPopup] = useState(false);
  const [filterSorting, setFilterSorting] = useState('filename');
  const [styleLeft, setStyleLeft] = useState(0);
  const [recentSearchList, setRecentSearchList] = useState([]);
  const [tabbingval, setTabbingval] = useState([]);
  const [quickViewData, setQuickViewData] = useState(false);
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [state_loader, setState_loader] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [data, setData] = useState([]);
  const [copyData, setCopyData] = useState([]);
  const [searchVal, setSearchVal] = useState('');
  const [active, setActive] = useState('');
  const [colormatch, setcolormatch] = useState(false);
  const [colormatchQuick, setcolormatchQuick] = useState(false);
  const [colormatchDelete, setcolormatchDelete] = useState(false);
  const inputval = useRef();
  const getUserEmail = sessionStorage.getItem('user_email');
  const getUserType = getUserEmail?.split('@')[1] === 'veolia.com' ? 'internal' : 'external';
  // ant design
  const [api, contextHolder] = notification.useNotification();
  const placement = 'topLeft';  // topLeft topRight
  const [columnWidths, setColumnWidths] = useState([270, 290, 200, 230]); // Default widths
  const [resizing, setResizing] = useState(null);
  // const [explorerData, setExplorerData] = useState([]);
  const [ShowFiles, setShowFiles] = useState(true);
  // const [fileName, setFileName] = useState(null);
  const [visitFirst, setVisitFirst] = useState(false);
  const [allMyListData, setAllMyListData] = useState([]); // Set All my project file list
  const [copyMyListData, setCopyMyListData] = useState([]); // Copy exiting data in my-project list
  const openModelPopUp = (message, title, type) => {
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      title,
      message,
      yesOrNo: false,
      onNo: () => setModalOption(defaultModalOptions),
      type
    });
  };
  function parseDate(dateStr) {
    if (!dateStr) {
      // console.error('Invalid date string:', dateStr);
      return new Date(); // Return current date or handle as error case
    }

    const [datePart, timePartWithZone] = dateStr.split(' (');
    if (!datePart || !timePartWithZone) {
      // console.error('Date string format error:', dateStr);
      return new Date(); // Return current date or handle as error case
    }

    const [day, month, year] = datePart.split('/');
    const [timePart] = timePartWithZone.split(')'); // Safely extract time part
    const [hours, minutes] = timePart.split(':');

    if (!day || !month || !year || !hours || !minutes) {
      // console.error('Date or time information missing:', dateStr);
      return new Date(); // Return current date or handle as error case
    }
    return new Date(year, month - 1, day, parseInt(hours, 10), parseInt(minutes, 10));
  }
  const sortedData = (str) => {
    if (filterSorting === 'filename' || filterSorting === 'projectname' || filterSorting === 'createdon' || filterSorting === 'lasteditedon') {
      const val = [...copyData];
      if (filterSorting === 'filename') {
        val.sort((a, b) => {
          if (str !== 'asc')
            return (a.name.toLowerCase() < b.name.toLowerCase()) ? 1 : -1;
          return (a.name.toLowerCase() < b.name.toLowerCase()) ? -1 : 1;
        });
      } else if (filterSorting === 'projectname') {
        val.sort((a, b) => {
          if (str !== 'asc')
            return (a.project_name.toLowerCase() < b.project_name.toLowerCase()) ? 1 : -1;
          return (a.project_name.toLowerCase() < b.project_name.toLowerCase()) ? -1 : 1;
        });
      } else if (filterSorting === 'createdon') {
        val.sort((a, b) => {
          const dateA = parseDate(a.created_on);
          const dateB = parseDate(b.created_on);

          if (str !== 'asc') {
            return dateB - dateA; // For descending order
          }
          return dateA - dateB; // For ascending order
        });
      } else if (filterSorting === 'lasteditedon') {
        val.sort((a, b) => {
          const dateA = parseDate(a.last_edited_on);
          const dateB = parseDate(b.last_edited_on);

          if (str !== 'asc') {
            return dateB - dateA; // For descending order
          }
          return dateA - dateB; // For ascending order
        });
      }
      setCopyData([...val]);
    }
    setShowSortingPopup(false);
  };
  const setValueStorage = (inval) => {
    if (inval) {
      let storeVal = localStorage.getItem('myProjectStorageVal');
      if (storeVal) {
        storeVal = JSON.parse(storeVal);
        if (storeVal[filterSorting]) {
          let flag = true;
          for (let i = 0; i < storeVal[filterSorting].length; i += 1) {
            if (inval === storeVal[filterSorting][i]) {
              flag = false;
              break;
            }
          }
          if (flag) {
            if (storeVal[filterSorting].length >= 3) {
              storeVal[filterSorting].pop();
            }
            storeVal[filterSorting].unshift(inval);
            localStorage.setItem('myProjectStorageVal', JSON.stringify(storeVal));
          }
        } else {
          storeVal[filterSorting] = [inval];
          localStorage.setItem('myProjectStorageVal', JSON.stringify(storeVal));
        }
      } else {
        const data = JSON.stringify({
          [filterSorting]: [inval]
        });
        localStorage.setItem('myProjectStorageVal', data);
      }
      const data = JSON.parse(localStorage.getItem('myProjectStorageVal'));
      setRecentSearchList(data[filterSorting]);
      setSearchVal('');
    }
  };
  const searchFilter = () => {
    const inval = inputval.current.value;
    if (!inval) {
      if (copyMyListData.length !== allMyListData.length) {
        setScrollMyData(true);
      }
      setData([...copyMyListData]);
      setCopyData([...copyMyListData]);
      setCopyMyListData([]);
      searchFilterflag = true;
      return false;
    }
    if (filterSorting === 'filename' || filterSorting === 'projectname') {
      let val = [...data];
      if (filterSorting === 'filename') {
        val = val.filter((ele) => {
          if (ele.name)
            return ele.name.toLowerCase().indexOf(inval.toLowerCase()) >= 0;
        });
      } else if (filterSorting === 'projectname') {
        val = val.filter((ele) => {
          if (ele.project_name)
            return ele.project_name.toLowerCase().indexOf(inval.toLowerCase()) >= 0;
        });
      }
      setCopyData([...val]);
    }
  };
  const searchFilterEnter = (eve) => {
    const inval = inputval.current.value;
    const keyCode = eve.keyCode || eve.which;
    if (inval && keyCode === 13) {
      setValueStorage(searchVal);
      setTimeout(() => {
        setShowSortingPopup(false);
        setSearchVal('');
      }, 0);
    } else {
      if (searchFilterflag) {
        if (data.length !== allMyListData.length) {
          setScrollMyData(false);
        }
        searchFilterflag = false;
        setCopyMyListData([...data]);
        setData([...allMyListData]);
      }
      searchFilter();
    }
  };

  const getFilterFlowSheetType = (data) => {
    const finalCombineData = {};
    data.map((ele) => {
      if (finalCombineData.flow_type) {
        if (ele.flow_type) {
          finalCombineData.flow_type.push(ele.flow_type);
          finalCombineData.flow_type = [...new Set(finalCombineData.flow_type)];
        }
      } else {
        finalCombineData.flow_type = [ele.flow_type];
      }
      if (ele.unittop_sneak_peak_view && Object.keys(ele.unittop_sneak_peak_view).length) {
        Object.keys(ele.unittop_sneak_peak_view).map((sneak) => {
          if (finalCombineData[sneak]) {
            finalCombineData[sneak] = finalCombineData[sneak].concat(ele.unittop_sneak_peak_view[sneak]);
            finalCombineData[sneak] = [...new Set(finalCombineData[sneak])];
          } else {
            finalCombineData[sneak] = ele.unittop_sneak_peak_view[sneak];
          }
        });
      }
      return ele;
    });
    const arr = [];
    Object.keys(finalCombineData).map((ele) => {
      let name = ele;
      if (name === 'flow_type') {
        name = 'Flow Sheet Type';
      } else if (name === 'Chemical_Dosing') {
        name = 'Chemical Dosing';
      }
      arr.push({ name, key: ele, data: finalCombineData[ele] });
    });
    setFlowSheetType(arr);
  };
  const resetQuickFilter = (eve) => {
    if (eve) eve.stopPropagation();
    if (applyUpdate) {
      setSelectedCities(null);
      setTabbingval([]);
    }
    setShowFilter(false);
  };
  const clearAll = (str = '') => {
    if (copyMyListData.length > 0) {
      setApplyUpdate(() => true);
      setSelectedCities(null);
      setTabbingval([]);
      setShowFilter(false);
      if (copyMyListData.length !== allMyListData.length) {
        setScrollMyData(true);
      }
      setData([...copyMyListData]);
      setCopyData([...copyMyListData]);
      setCopyMyListData([]);
      searchFilterflag = true;
    } else if (str === 'filterClear' || applyAllStr) {
      setApplyUpdate(() => true);
      setSelectedCities(null);
      setTabbingval([]);
      setShowFilter(false);
      setCopyData([...data]);
    }
    applyAllStr = false;
  };
  const applyFilter = () => {
    applyAllStr = true;
    const val = [...data];
    const type = flowSheetType.filter((ele) => ele.name === selectedCities);
    if (type.length) {
      if (type[0].key === 'flow_type') {
        const filterVal = val.filter(ele => tabbingval.indexOf(ele.flow_type) >= 0);
        setCopyData([...filterVal]);
      } else {
        const filterVal = [];
        val.forEach(ele => {
          if (ele.unittop_sneak_peak_view && Object.keys(ele.unittop_sneak_peak_view) && Object.keys(ele.unittop_sneak_peak_view).indexOf(type[0].key) >= 0) {
            tabbingval.forEach((d) => {
              if (ele.unittop_sneak_peak_view[type[0].key].indexOf(d) >= 0) {
                const filterdata = filterVal.filter((val) => {
                  return (val.name === ele.name && val.project_name === ele.project_name && val.filename === ele.filename);
                });
                if (filterdata.length === 0)
                  filterVal.push(ele);
              }
            });
          }
        });
        setCopyData([...filterVal]);
      }
    }
    setApplyUpdate(false);
    setShowFilter(false);

  };
  const setOnlyMyFile = (resFiles) => {
    const resultData = resFiles.map(item => {
      item.name = item.filename.split('.json')[0];
      return item;
    });
    setFetchLoading(false);
    setData((prev) => [...prev, ...resultData]);
    setCopyData((prev) => [...prev, ...resultData]);
    setPageNumber(pageNumber + 1);
    getFilterFlowSheetType([...data, ...resultData]);
  };
  const getFlowSheetFilterWrapperHeight = () => {
    setTimeout(() => {
      if (document.querySelector('.navbar-menu') && document.querySelector('.wrapper-sort') && document.querySelector('.flow-sheet-filter-wrapper')) {
        const h1 = document.querySelector('.navbar-menu').offsetHeight;
        const t1 = document.querySelector('.wrapper-sort').offsetTop;
        const t2 = document.querySelector('.flow-sheet-filter-wrapper').offsetTop;
        if (t2 > 0) {
          const t3 = document.querySelector('.flow-sheet-filter-wrapper').offsetHeight;
          const total = h1 + t1 + t2 + t3;
          if (window.innerHeight < total) {
            document.querySelector('.flow-sheet-filter-wrapper').style.setProperty('bottom', '0', '');
          } else {
            document.querySelector('.flow-sheet-filter-wrapper').style.setProperty('bottom', '', '');
          }
        }
      }
    }, 100);
  };
  const getMyProjectListData = async () => {
    try {
      const dataMyProject = await getMyProjectsList(getUserEmail, getUserType, pageNumber, dataLimit, 'my_projects');
      const response = dataMyProject.data;
      copyofMyFilesLength = response.filecount;
      const resFiles = decryptDataSharedAndMyProject(response);
      // Process and set data
      setOnlyMyFile(resFiles);
      if (copyofMyFilesLength === [...data, ...resFiles].length) {
        setScrollMyData(false);
        setTimeout(() => {
          if (document.getElementById('infinite-loader')) document.getElementById('infinite-loader').classList.add('hide');
        }, 100);
      }
      setVisitFirst(true);
    } catch (error) {
      console.error('Error fetching project list data:', error);
      setScrollMyData(false);
    }
  };

  // Utility function to check if an element has a scrollbar
  const hasScrollbar = element =>
    element && (element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth);

  useEffect(() => {
    const scrollableDiv = document.getElementById('sidebarScrollableDiv'); // By Abhishek on 23-June-25 : to fixed issue: when fileCount was <= 10, then we are seeing repeated files
    if (scrollableDiv && !hasScrollbar(scrollableDiv) && pageNumber !== 1 && copyofMyFilesLength !== copyData.length) {
      getMyProjectListData();
    }
  }, [pageNumber]);
  useEffect(async () => {
    getFlowSheetFilterWrapperHeight();
    removeItemFromLocalStorage();
    removeLocalStorageValue();
    getMyProjectListData();
  }, []);
  const closeQuickViewPopup = () => {
    setShowQuickViewPopup(false);
    setcolormatchQuick(false);
  };

  const openQuickView = (ele) => {
    setcolormatchQuick(true);
    setQuickViewData(ele);
    setShowQuickViewPopup(true);
  };

  const filterPopup = (ele, ind, event) => {
    event.stopPropagation();
    if (['filename', 'projectname', 'createdon', 'lasteditedon'].indexOf(ele.str) >= 0) {
      setFilterSorting(ele.str);
      setShowSortingPopup(true);
      const finalLeft = (event.target.closest('li').offsetLeft + 10);
      setStyleLeft(finalLeft);
      const data = JSON.parse(localStorage.getItem('myProjectStorageVal'));
      setRecentSearchList([]);
      if (data[ele.str]) { setRecentSearchList(data[ele.str]); }
    } else if (ele === 'filterstr') {
      setShowFilter(true);
      getFlowSheetFilterWrapperHeight();
    }
  };

  const shareFileData = (data) => {
    ColorChangeShare = true;
    setcolormatch(true);
    setText(data.name);
    setValue(data);
    setVisible_fileSharing(true);
    // setcolormatch('transparent');
  };

  const searchByrecent = (ele) => {
    setSearchVal(ele);
    searchFilterflag = true;
    inputval.current.value = ele;
    if (searchFilterflag) {
      if (data.length !== allMyListData.length) {
        setScrollMyData(false);
      }
      searchFilterflag = false;
      setCopyMyListData([...data]);
      setData([...allMyListData]);
    }
    setTimeout(() => {
      setShowSortingPopup(false);
      setSearchVal('');
    }, 100);
  };
  useEffect(() => {
    if (copyMyListData.length > 0) {
      searchFilter();
    }
  }, [copyMyListData]);
  const downloadFile = (ele) => {
    DownloadMainfile(ele);
  };

  // delete win and project file start
  const deleteWinAndProjectFileFromS3 = (ele) => {
    setModalOption(defaultModalOptions);
    setcolormatchDelete(false);

    const deletedFileName = `${ele.name}.json`;

    const data = {};
    data.files = { '0': `${getUserEmail}_${deletedFileName}` };

    setState_loader(true);
    // calling the api and sending getUserEmail as param1, getUserType as param2 and JSON.stringify(data.files) as data
    deleteWinAndProjectFile(getUserEmail, getUserType, JSON.stringify(data.files))
      .then((res) => {
        if (res.data !== 'Failed to delete files from s3') {
          setState_loader(false);
          // removing the deleted file form copyData array
          const newCopyData = copyData.filter(item => item.name !== ele.name);
          // setting the filtered data into copyData array
          setCopyData([...newCopyData]);
          // 500 ms is required to refresh the table value
          // setTimeout(() => { }, 500);
          // updating the stored service file for the fast access
          const getVal = getMyAndSharedFile();
          delete getVal[deletedFileName];
          setMyAndSharedFile(getVal);
          // setTimeout(() => { }, 500);
          // showing the successfull notification
          api.success({
            message: translateObject('File deleted succesfully'),
            // description: '',
            placement,
            closable: false,
            icon: null
          });
        }
        else {
          setState_loader(false);
          api.error({
            message: translateObject('Error while deleting file'),
            // description: '',
            placement,
            closable: false,
            icon: null
          });
        }
      })
      .catch(() => { // if any error occur while deleting file
        setState_loader(false);
        api.error({
          message: translateObject('Error while deleting file'),
          // description: '',
          placement,
          closable: false,
          icon: null
        });
      });

  };
  // delete win and project file ends

  const handleDeleteFile = (ele) => {
    setcolormatchDelete(true);
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      title: 'Warning',
      message: translateObject('Are you sure you want to delete it?'),
      yesOrNo: true,
      onNo: () => {
        setModalOption(defaultModalOptions);
        setcolormatchDelete(false);
      },
      onYes: () => deleteWinAndProjectFileFromS3(ele),
    });
  };
  const handleFormSubmit = async (type, email) => {
    setState_loader(true);
    if (value && value.name) {
      const name = `${value.name}.json`;

      getWinflowsFileContent(getUserEmail, name, getUserType)
        .then((response) => {
          if (email) {
            if (response.data[0] !== '{' && response.data[0] !== undefined) {
              const res_data = response.data.split('"')[1];
              if (res_data) {
                response.data = decrypt_data(res_data);
              } else {
                response.data = decrypt_data(response.data);
              }
            } else {
              const final_data = response.data; // JSON.parse(response.data);
              response.data = final_data;
            }
            const FlowData = response.data;
            const params = { file_name: `${getUserEmail}_${text}.json` };
            checkFileExists(params).then((res) => {
              const { exist } = res.data;
              let sharedFileName = '';
              if (exist) {
                const randomNum = Math.random().toString(36).slice(2, 5);
                if (text.indexOf('-sharedFile') < 0) {
                  sharedFileName = `${text}_${randomNum}-sharedFile.json`;
                } else {
                  const finalName = text.split('-sharedFile')[0];
                  sharedFileName = `${finalName}_${randomNum}-sharedFile.json`;
                }
              } else if (text.indexOf('-sharedFile') < 0) {
                sharedFileName = `${text}-sharedFile.json`;
              } else {
                const finalName = text.split('-sharedFile')[0];
                sharedFileName = `${finalName}-sharedFile.json`;
              }
              // Update shared by whom
              FlowData.projectInfo_dict.sharedby = sessionStorage.getItem('user_name');
              FlowData.projectInfo_dict.isRead = false;

              const cipher_new = encrypt_data(FlowData);
              Promise.all(email.map(userEmail => {
                saveWinflowsFileContent(sharedFileName, userEmail, getEmailUserType(userEmail), cipher_new);
              }))
                .then(() => {
                  setState_loader(false);
                  openModelPopUp(translateObject('File shared successfully!.'), 'Success!', 'success');
                });
            });
          }
        })
        .catch(() => {
          setState_loader(false);
          openModelPopUp('Failed to save feed input', 'Error', 'error');
        });
    }
  };
  const activeTabSet = (ele) => {
    const selectedArr = tabbingval;
    if (selectedArr.indexOf(ele) < 0) {
      selectedArr.push(ele);
    } else {
      selectedArr.splice(selectedArr.indexOf(ele), 1);
    }
    setTabbingval(() => {
      return [...selectedArr];
    });
  };
  const handleChange = (event) => {
    setSelectedCities(event.target.value);
    const data = flowSheetType.filter((ele) => {
      return ele.name === event.target.value;
    });
    if (data.length) {
      setSubflowSheetType(() => { return { ...data[0] }; });
      setTabbingval([]);
    }
    getFlowSheetFilterWrapperHeight();
  };
  const handleMouseDown = (index) => (e) => {
    setResizing(index);
    const startX = e.clientX;
    const startWidth = columnWidths[index];

    const handleMouseMove = (e) => {
      const currentWidth = startWidth + e.clientX - startX;
      const newWidths = [...columnWidths];
      newWidths[index] = currentWidth;
      setColumnWidths(newWidths);
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      setResizing(null);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };
  useEffect(async () => {
    const flag_my_project_api = get_checkAPI_My_Project();
    if (flag_my_project_api) {
      set_checkAPI_My_Project();
      const resultData = await getMyProjectAllData(getUserEmail, getUserType);
      setAllMyListData(resultData);
    } else {
      const data = get_all_my_projects_list();
      if (data && Object.prototype.toString.call(data) === '[object Array]') {
        setAllMyListData(data);
      } else {
        const flagMyList = setInterval(() => {
          const mydata = get_all_my_projects_list();
          if (mydata) {
            clearInterval(flagMyList);
            setAllMyListData(mydata);
          }
        }, 1000);
      }
    }
  }, []);
  return (
    <div onClick={() => { setValueStorage(searchVal); resetQuickFilter(''); setShowSortingPopup(false); }}>
      {contextHolder}
      <div style={{ backgroundColor: '#FFF', height: '0px' }} />
      <div style={{ backgroundColor: 'white' }}>
        <HeaderSection />
        <Notification options={modalOption} handleClose={() => setModalOption(defaultModalOptions)} />
        <Backdrop open={fetchLoading || state_loader} style={{ 'zIndex': 1, backgroundColor: 'transparent' }}>
          <CircularProgress color="inherit" style={{ color: '#4b93f4' }} />
        </Backdrop>
        <div style={{ opacity: fetchLoading ? 0 : 1 }} className='my-projects-box'>
          <span className="my-project-header" style={{ display: 'flex' }}>
            <span className="L_heading forground-text-primary" style={{ marginLeft: 48, marginTop: 18, marginBottom: 18 }}>{translateObject('My Projects')}</span>
            <span className="my-project-list" style={{ marginLeft: 32, marginTop: 18, marginBottom: 18, display: 'flex', alignItems: 'center' }}>
              <ul>
                <li onClick={() => { setCurrentActiveTab(0); }} className={`${currentActiveTab === 0 ? 'active B_Bold' : 'B_Bold'}`}>{translateObject('All')}({copyData.length})</li>
                <li style={{ marginLeft: '16px' }} onClick={() => { setCurrentActiveTab(1); }} className={`${currentActiveTab === 1 ? 'active B_Bold' : 'B_Bold'}`}>{translateObject('Current')} (-)</li>
                <li style={{ marginLeft: '16px' }} onClick={() => { setCurrentActiveTab(2); }} className={`${currentActiveTab === 2 ? 'active B_Bold' : 'B_Bold'}`}>{translateObject('Archive')} (-)</li>
              </ul>
            </span>
          </span>
          <div className='landing-wrapper-my-project hide-folder-structure'>
            <div className="wrapper-sort">
              <div className="wrapper-sort_header">
                <ul className="wrapper-sort_header-sticky" style={{ background: 'none', marginBottom: '4px' }} >
                  {[{ 'str': 'filename', 'text': translateObject('File Name') }, { 'str': 'projectname', 'text': translateObject('Project Name') }, { 'str': 'createdon', 'text': translateObject('Created On') }, { 'str': 'lasteditedon', 'text': translateObject('Last Edited On') }].map((ele, ind) => {
                    return (
                      <li key={ind} className={`resizable ${ele.text.toLowerCase().split(' ').join('-')}`} style={{ width: `${columnWidths[ind]}px` }}>
                        {ele.text}
                        {(['createdon', 'lasteditedon'].indexOf(ele.str) < 0) &&
                          <span className="icon_filter" onClick={(event) => filterPopup(ele, ind, event)}>
                            <img src={filter_list} />
                          </span>
                        }
                        {(['filename', 'projectname'].indexOf(ele.str) < 0) &&
                          <span className="icon_filter" onClick={(event) => filterPopup(ele, ind, event)}>
                            <img src={filter_list} />
                          </span>
                        }
                        {['filename', 'projectname', 'createdon'].includes(ele.str) && (
                          <div className="resize-handle" style={{
                            borderLeft: resizing === ind ? '3px solid #0679CC' : '3px solid #002D62'
                          }} onMouseDown={handleMouseDown(ind)} />
                        )}
                      </li>
                    );
                  })}
                  <li className='' style={{ width: '34%', justifyContent: 'end', marginRight: '0px', marginBottom: '12px' }}>
                    <Tooltip title='Filter' placement="bottom" arrow>
                      <div className='reset-filter' onClick={(event) => { filterPopup('filterstr', 0, event); }} style={{ marginRight: '8px' }}>
                        <img src={filter_alt} />
                        {!applyUpdate && (<div className='filter-count'>{tabbingval.length}</div>)}
                      </div>
                    </Tooltip>
                    <Tooltip title='Reset' placement="bottom" arrow>
                      <div className='reset-filter' onClick={() => { clearAll(); }}>
                        <img src={Icon_Button_Restart} alt='reset' />
                      </div>
                    </Tooltip>
                  </li>
                </ul>
                {showSortingPopup && (
                  <div onClick={(event) => { event.stopPropagation(); }} className='quick-view-filter' style={{ 'left': `${styleLeft}px`, height: 'auto' }}>
                    {filterSorting === 'filename' &&
                      <div className="input-containers" style={{ marginBottom: '5px' }}>
                        <input ref={inputval} placeholder={translateObject('Enter name to Search')} type="text" name="search" value={searchVal} onKeyUp={(e) => { searchFilterEnter(e); }} onChange={(e) => setSearchVal(e.target.value)} />
                        <img onClick={() => { setValueStorage(searchVal); setShowSortingPopup(false); }} src={searchImage} alt='search-icon' />
                      </div>
                    }
                    {filterSorting === 'projectname' &&
                      <div className="input-containers" style={{ marginBottom: '5px' }}>
                        <input ref={inputval} placeholder={translateObject('Enter name to Search')} type="text" name="search" value={searchVal} onKeyUp={(e) => { searchFilterEnter(e); }} onChange={(e) => setSearchVal(e.target.value)} />
                        <img onClick={() => { setValueStorage(searchVal); setShowSortingPopup(false); }} src={searchImage} alt='search-icon' />
                      </div>
                    }
                    {(recentSearchList.length > 0) && (
                      <div className='quick-view-recent-search'>
                        <div className='recent-placeholder S_Regular'><span>{translateObject('Recent Search')}</span> <span className='hl' /></div>
                        <ul className='quick-view-recent-search-list'>
                          {recentSearchList && recentSearchList.map((ele, ind) => {
                            return (<li onClick={() => { searchByrecent(ele); }} className='S_Regular' key={ind}><span>{ele}</span></li>);
                          })}
                        </ul>
                      </div>
                    )}
                    <div className='quick-sort'>
                      <div className='recent-placeholder S_Regular'><span>{translateObject('Sorting')}</span> <span className='hl' /></div>
                      <ul>
                        <li onClick={() => sortedData('asc')}>
                          <div className='asc'>
                            <img src={sortAlphaImageAZ} />
                            <span className='S_Regular'>Sort A to Z</span>
                          </div>
                        </li>
                        <li onClick={() => sortedData('desc')}>
                          <div className='asc'>
                            <img src={sortAlphaImageZA} />
                            <span className='S_Regular'>Sort Z to A</span>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
              {showFilter && (
                <div className='flow-sheet-filter-wrapper'>
                  <div className='flow-sheet-filter'>
                    <div className='flow-sheet-filter-header'>
                      <div className='flow-filter-head'>
                        <span>{translateObject('Filters')}</span>
                        <Tooltip title="Close" onClick={(event) => { resetQuickFilter(event); }}>
                          <img src={closeIconBlack} alt="close" style={{ display: 'block' }} className="pointer" />
                        </Tooltip>
                      </div>
                      <div className='flow-filter-subhead'>{translateObject('Choose any one parameter')}</div>
                    </div>
                    <div onClick={(event) => { event.stopPropagation(); }} className='flow-quick-view-filter'>
                      <div className="flow-input-containers">
                        <FormControl>
                          <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue="female"
                            name="radio-buttons-group"
                            value={selectedCities}
                            onChange={(event) => handleChange(event)}
                          >
                            {flowSheetType.length && flowSheetType.map((ele, ind) => {
                              return <FormControlLabel className='quick-view-filter-content' key={ind} value={ele.name} control={<Radio size="small" sx={{
                                color: '#0679CC',
                                '&.Mui-checked': {
                                  color: '#0679CC',
                                },
                              }} />} label={ele.name} />;
                            })}
                          </RadioGroup>
                        </FormControl>
                        {selectedCities && (
                          <div className='filter-content'>
                            {Object.keys(subflowSheetType).length > 0 && subflowSheetType.data.map((ele, ind) => {
                              return (
                                <div className={`S_Regular ${tabbingval.indexOf(ele) >= 0 ? 'active' : ''}`} onClick={() => activeTabSet(ele)} key={ind} style={ind === subflowSheetType.data.length - 1 ? { marginBottom: '5px' } : {}}>
                                  <span><img src={filterCheck} alt='' /></span>
                                  <span key={ind}>{ele === 'E-Cell-3X' ? 'MK-5' : ele}</span>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                      <div className='sub-head-filter'>
                        <Button className='clear-all M_Bold ' onClick={() => { clearAll('filterClear'); }}>{translateObject('Clear All')}</Button>
                        <Button className='ok-btn ' disabled={tabbingval.length === 0} onClick={() => { applyFilter(); }}>{translateObject('Apply')}</Button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {ShowFiles &&
                <div className="wrapper-sort_list" id="sidebarScrollableDiv">
                  <InfiniteScroll scrollableTarget="sidebarScrollableDiv" dataLength={copyData.length} next={() => getMyProjectListData()} hasMore={scrollMyData} loader={<span id='infinite-loader' className='infinite-loader' />}>
                    {copyData.map((ele, ind) => {
                      return (
                        <ul onClick={() => setActive(copyData[ind].name)} key={ind} className={`wrapper-sort_inner S_Regular ${active === ele.name ? 'active' : ''}`} style={{ marginBottom: '4px' }}>
                          <li className='forground-text-primary' title={ele.name} style={{ width: `${columnWidths[0]}px`, borderRight: '2px solid white' }}>
                            <Tooltip title={ele.name} placement="right" arrow>
                              <Link to={`/main?${ele.name}.json`}> {ele.name} </Link>
                            </Tooltip>
                          </li>
                          <li className='Forground-Text-Label' style={{ width: `${columnWidths[1]}px`, borderRight: '2px solid white' }}><span className='text_label_formate'>{ele.project_name ? ele.project_name : '--'}</span></li>
                          <li className='Forground-Text-Label' style={{ width: `${columnWidths[2]}px`, borderRight: '2px solid white' }}><span className='text_label_formate'>{ele.created_on ? ele.created_on : '--'}</span></li>
                          <li className='Forground-Text-Label' style={{ width: `${columnWidths[3]}px` }}><span className='text_label_formate'>{ele.last_edited_on ? ele.last_edited_on : '--'}</span></li>
                          <li>
                            <div className="sharing_button">
                              <Tooltip title="Open File" placement="bottom" arrow>
                                <span className="icon_button" onClick={() => { navigate(`/main?${ele.name}.json`); }}>
                                  <img src={folder_open_icon} />
                                </span>
                              </Tooltip>
                              <Tooltip title="Share File" placement="bottom" arrow>
                                <span className={`icon_button ${colormatch ? 'changeBackgroudcolor' : ''}`}
                                  onClick={() => { shareFileData(ele); }}>
                                  <img src={shareImage} />
                                </span>
                              </Tooltip>
                              <Tooltip title="Quick View" placement="bottom" arrow>
                                <span onClick={() => { openQuickView(ele, ind); }} className={`icon_button ${colormatchQuick ? 'changeBackgroudcolorQuick' : ''}`}>
                                  <img src={quickViewImage} />
                                </span>
                              </Tooltip>
                              <Tooltip title="Download File" placement="bottom" arrow>
                                <span className="icon_button" onClick={() => { downloadFile(ele); }}>
                                  <img src={DownloadSvgIcon} />
                                </span>
                              </Tooltip>
                              <Tooltip title="Delete File" placement="bottom" arrow>
                                <span onClick={() => { handleDeleteFile(ele, ind); }} className={`icon_button ${colormatchDelete ? 'changeBackgroudcolorDelete' : ''}`}>
                                  <img src={deleteImage} />
                                </span>
                              </Tooltip>
                            </div>
                          </li>
                        </ul>
                      );
                    })}
                  </InfiniteScroll>
                  {(copyData.length === 0 && visitFirst) && (
                    <div className='no-data-found'>{translateObject('No Data Found...')}</div>
                  )}
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      {showQuickViewPopup && (
        <div className="file-share-draggable">
          <QuickViewPopUp
            visibleQuickView={showQuickViewPopup}
            closeQuickViewPopup={closeQuickViewPopup}
            quickViewData={quickViewData}
            translateObject={translateObject}
          />
        </div>
      )}
      {visible_fileSharing && (
        <div className="file-share-draggable">
          <FileShare
            visible_fileSharing={visible_fileSharing}
            setVisible_fileSharing={setVisible_fileSharing}
            setcolormatch={setcolormatch}
            ColorChangeShare={ColorChangeShare}
            text={`${text}-sharedFile`}
            onSave_saveButton={handleFormSubmit}
          />
        </div>
      )}
    </div >
  );
};

export default MyProjectsPopup;